import { useState, useEffect } from 'react';

const VIEW_MODE_STORAGE_KEY = 'filmudb_view_mode';

function useViewMode() {
  // Initialize from localStorage or default to 'grid'
  const [viewMode, setViewMode] = useState(() => {
    try {
      const stored = localStorage.getItem(VIEW_MODE_STORAGE_KEY);
      if (stored && (stored === 'grid' || stored === 'list')) {
        return stored;
      }
    } catch (error) {
      console.error('Error reading view mode from localStorage:', error);
    }
    return 'grid';
  });

  // Save to localStorage whenever viewMode changes
  useEffect(() => {
    try {
      localStorage.setItem(VIEW_MODE_STORAGE_KEY, viewMode);
    } catch (error) {
      console.error('Error saving view mode to localStorage:', error);
    }
  }, [viewMode]);

  return [viewMode, setViewMode];
}

export default useViewMode;
